import { Col, Row, Spin, DatePicker, Button, Input } from "antd";
import moment from 'moment-timezone';
import React, { useEffect, useState } from "react";
import AppTable from "../../components/AppTable/AppTable";
import axiosGet from "../../helpers/AxiosRequest";
import { UrlConstants } from "../../helpers/UrlConstantsHelper";
import { CSVLink } from "react-csv";
import { DownloadOutlined } from '@ant-design/icons';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const Drholdreport = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [drholdList, setdrholdList] = useState([]);
  const [copydrholdList, setcopydrholdList] = useState([]);
  const [fromdate, setfromdate]: any = useState(moment());
  const [ButtonClicked, setIsButtonClicked] = useState("Today");
  const [todayFlag, setTodayFlag] = useState(false);
  const [prevFlag, setPrevFlag] = useState(false);
  const [todate, settodate]: any = useState(moment());
  const dateFormat = "DD/MM/YYYY";
  const [totalCount, setTotalCount] = useState(0);
  const [SearchText, setsearchText]: any = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const disabledDate = (current: any) => {
    return current && current > moment().endOf("day");
  };
  const disabledFromDate = (current: any) => {
    return current && current > moment(todate).endOf("day");
  };
  const onDateSearch = (
    fromdate: any,
    todate: any,
  ) => {
    DateSearch(
      moment(fromdate).format("YYYY/MM/DD"),
      moment(todate).add("days", 1).format("YYYY/MM/DD"),
    );
  };
  const DateSearch = (
    fromdate: any,
    todate: any,
  ) => {
    setIsLoading(true);
    const options: any = {
      params: {
        fromdate: fromdate,
        todate: todate,
      },
    };
    axiosGet(UrlConstants.getdrHoldReport, options)
      .then((resp: any) => {
        resp.forEach((e: any) => {
          e.key = e._id.toString();
        });
        setIsLoading(false);
        setdrholdList(resp);
        setcopydrholdList(resp);
        setTotalCount(resp.tablelength);
      })
      .catch(function (error: any) {
        setIsLoading(false);
        if (error.response) {
          console.log(error.response.data, error.response.status);
          setdrholdList([]);
          setcopydrholdList([]);
        }
      });
  };


  const onSearchchange = (e: any) => {
    setsearchText(e.target.value);
    globalSearch(e.target.value);
  };
  const globalSearch = (searchText: any) => {
    let filteredData = drholdList.filter((value: any) => {
      if (value.cabId === undefined || value.cabId === null) value.cabId = "";
      if (value.releaseby === undefined || value.releaseby === null) value.releaseby = "";
      if (value.holdBy === undefined || value.holdBy === null) value.holdBy = "";
      return (
        value.cabId
          .toString()
          .toLowerCase()
          .includes(searchText.toLowerCase()) ||
        value.releaseby
          .toString()
          .toLowerCase()
          .includes(searchText.toLowerCase()) ||
        value.holdBy
          .toString()
          .toLowerCase()
          .includes(searchText.toLowerCase())
      );
    });
    setcopydrholdList(filteredData);
    setFilteredData(filteredData);
  };

  const columns = [
    {
      title: "Date",
      dataIndex: "holdDate",
      key: "Date",
      render: (text: any, record: any) => {
        return {
          children: (
            <div>
              {text ? moment(text).format("DD/MM/YYYY") : ""}
            </div>
          ),
        };
      },
    },
    {
      title: "Hold time",
      dataIndex: "holdDate",
      key: "Date",
      render: (text: any, record: any) => {
        return {
          children: (
            <div>
              {text ? moment(text).format("hh:mm A") : ""}
            </div>
          ),
        };
      },
    },
    {
      title: "Cab Id",
      dataIndex: "cabId",
      key: "Cab Id",
    },
    {
      title: "Release time",
      dataIndex: "releasetime",
      key: "reltime",
      render: (text: any, record: any) => {
        return {
          children: (
            <div>
              {text ? moment(text).format("hh:mm A") : ""}
            </div>
          ),
        };
      },
    },

    {
      title: "Release By",
      dataIndex: "releaseby",
      key: "releby",
    },
    {
      title: "Hold By",
      dataIndex: "holdBy",
      key: "holdby",
    },
  ];

  const headersToExport = columns.map((column: any) => ({
    label: column.title,
    key: column.dataIndex || column.title, // Make sure there's a fallback for undefined keys
  }));

  const csvData = drholdList.map((value: any) => ({
    ...value,
    permTime: value.permTime ? moment(value.permTime).format("hh:mm A") : "",
    resumeTime: value.resumeTime ? moment(value.resumeTime).format("hh:mm A") : "",
    pStartTime: value.pStartTime ? moment(value.pStartTime).format("hh:mm A") : "",
  }));

  const adayclick = (event: any = null) => {

    var first = moment();
    var firstday = first.format("DD");
    var firstmonth = first.format("MM");
    var firstyear = first.format("YYYY");
    let fromdate = firstyear + "-" + firstmonth + "-" + firstday;
    setfromdate(moment(fromdate));
    //var new_date = moment().add('days', 1);
    var new_date = moment();
    var day = new_date.format("DD");
    var month = new_date.format("MM");
    var year = new_date.format("YYYY");
    let todate = year + "-" + month + "-" + day;
    settodate(moment(todate));
    setTodayFlag(true);
    setPrevFlag(false);
    onDateSearch(fromdate, todate);
  };
  const twodayclick = () => {
    setIsButtonClicked("Yesday");
    var first = moment().add("days", -1);
    var firstday = first.format("DD");
    var firstmonth = first.format("MM");
    var firstyear = first.format("YYYY");
    let fromdate = firstyear + "-" + firstmonth + "-" + firstday;
    setfromdate(moment(fromdate));
    var new_date = moment().add("days", -1);
    //var new_date = moment();
    var day = new_date.format("DD");
    var month = new_date.format("MM");
    var year = new_date.format("YYYY");
    let todate = year + "-" + month + "-" + day;
    settodate(moment(todate));
    setTodayFlag(false);
    setPrevFlag(true);
    onDateSearch(fromdate, todate);
  };
  const monthclick = () => {
    setIsButtonClicked("Month");
    var first = moment();
    var firstmonth = first.format("MM");
    var firstyear = first.format("YYYY");
    let fromdate = firstyear + "-" + firstmonth + "-" + "01";
    setfromdate(moment(fromdate));
    //var new_date = moment().add('days', 1);
    var new_date = moment();
    var day = new_date.format("DD");
    var month = new_date.format("MM");
    var year = new_date.format("YYYY");
    let todate = year + "-" + month + "-" + day;
    settodate(moment(todate));
    setTodayFlag(true);
    setPrevFlag(false);
    onDateSearch(fromdate, todate);
  };

  useEffect(() => {
    // getCustomerList();
    adayclick();
  }, []);
  const onfromdatechange = (value: any) => {
    setfromdate(value);
    try {
      var fromdate = moment(value).format("YYYY/MM/DD");
      let todate = moment().format("YYYY/MM/DD");
      //DateSearch(fromdate, todate);
      setTodayFlag(false);
      setPrevFlag(false);
      //setfromdate(value);
    } catch (ex) {
      console.log(ex);
    }
  };
  const ontodatechange = (value: any) => {
    settodate(value);
    try {
      let startdate = moment(fromdate).format("YYYY/MM/DD");
      //DateSearch(startdate, todate);
      setTodayFlag(false);
      setPrevFlag(false);

      //settodate(moment(todate));
    } catch (ex) {
      console.log(ex);
    }
  };
  const today = moment().format("DD-MM-YYYY");
  const exportToCSV = (data: any[], columns: any[], fileName = `Hold Report`) => {
    const exportData = data.map((row) => {
      const formattedRow: any = {};

      columns.forEach((col: any) => {
        const key = col.dataIndex;
        if (key === "holdDate") {
          formattedRow["Hold time"] = moment.tz(row.bookingDate, "UTC").tz("Asia/Kolkata").format("hh:mm A");
        }
        else if (key === "releasetime") {
          formattedRow["Release time"] = moment.tz(row.bookingDate, "UTC").tz("Asia/Kolkata").format("hh:mm A");
        }
        else if (key === "holdDate") {
          formattedRow["Date"] = moment.tz(row.bookingDate, "UTC").tz("Asia/Kolkata").format("DD/MM/YYYY");
        }

        else if (typeof key === "string") {
          formattedRow[col.title.trim()] = row[key];
        }
      });

      return formattedRow;
    });
    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const dataBlob = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });
    saveAs(dataBlob, `${fileName}.xlsx`);
  };


  return (
    <div className="booking-child-routes">
      <div className="booking-child-routes-button-section">

        <Row style={{ paddingBottom: 10 }}>
          <Col>
            <span
              style={{
                fontSize: "large",
                fontWeight: "bold",
                fontStyle: "Times New Roman",
              }}
            >
              HOLD REPORT
            </span>
          </Col>
          <Col span={3} offset={10}>
            <span style={{ fontSize: "large", fontWeight: "bold" }}>
              Count :   {drholdList.length}
            </span>
          </Col>
        </Row>
        <Row>

          <Col flex="auto" span={8} >
            <span style={{ fontSize: "medium" }}> From:</span>

            <DatePicker
              value={fromdate}
              format={dateFormat}
              disabledDate={disabledFromDate}
              onChange={onfromdatechange}
            />
            <span style={{ fontSize: "medium" }}> To:</span>

            <DatePicker
              //value={todate}
              value={
                todayFlag
                  ? moment()
                  : prevFlag
                    ? moment().add("days", -1)
                    : todate
              }
              format={dateFormat}
              disabledDate={disabledDate}
              onChange={ontodatechange}
            />

          </Col>


          <Col span={2} offset={0}>
            <Button
              className="booking-btn-blockSearch"
              onClick={() =>
                onDateSearch(fromdate, todate)
              }
              disabled={moment(fromdate).isAfter(moment(todate))}
            >
              Search
            </Button>
          </Col>
          <Col span={2} offset={1}>
            <Button
              className={
                ButtonClicked === "Today"
                  ? "booking-btn-buttonTrue"
                  : "booking-btn-buttonFalse"
              }
              onClick={adayclick}
            >
              Today
            </Button>
          </Col>
          <Col span={2} offset={0}>
            <Button
              className={
                ButtonClicked === "Yesday"
                  ? "booking-btn-buttonTrue"
                  : "booking-btn-buttonFalse"
              }
              onClick={twodayclick}
            >
              Prev
            </Button>
          </Col>
          <Col span={2} offset={0}>
            <Button
              className={
                ButtonClicked === "Month"
                  ? "booking-btn-buttonTrue"
                  : "booking-btn-buttonFalse"
              }
              onClick={monthclick}
            >
              Month
            </Button>
          </Col>
          <Col span={2} offset={1}>
            <Button icon={<DownloadOutlined />} type="primary" onClick={() => exportToCSV(copydrholdList, columns)}>
            </Button>
          </Col>
          <Col span={3} offset={1}>
            <Input
              placeholder="Search Text"
              className="search"
              onChange={onSearchchange}
              allowClear
            />
          </Col>
        </Row>
        <div>
          <Spin tip="Loading..." spinning={isLoading}>
            <AppTable
              columns={columns}
              data={copydrholdList}
              enablePagination={true}
              defaultPageSize={100}
              scroll={{ x: "max-content" }}
            ></AppTable>
          </Spin>
        </div>
      </div>
    </div>
  );
};

export default Drholdreport;
